module.exports = __webpack_public_path__ + "img/mbh2.26f32cac.jpg";